<template>
  <div class="social-links">
    <a v-for="(val, key) in elements" :key="key" :href="val.url" target="_blank" class="social-links__icon" :title="`Link ${val.name}`">
      <Icon :name="val.icon" :size="22" color="none" />
    </a>
  </div>
</template>

<script>
import Icon from '@/lego/components/icons/Icon.vue';

export default {
  components: {
    Icon,
  },
  setup() {
    return {
      elements: {
        TikTok: {
          url: 'https://www.tiktok.com/@trioteca/',
          icon: 'tiktok',
          name: 'TikTok',
        },
        Facebook: {
          url: 'https://www.facebook.com/trioteca/',
          icon: 'facebook',
          name: 'Facebook',
        },
        Instagram: {
          url: 'https://www.instagram.com/trioteca/',
          icon: 'instagram',
          name: 'Instagram',
        },
        LinkedIn: {
          url: 'https://www.linkedin.com/company/trioteca/',
          icon: 'linkedin',
          name: 'LinkedIn',
        },
        YouTube: {
          url: 'https://www.youtube.com/channel/UC_UX3wj0jeQ1_1XP-m4TdHQ',
          icon: 'youtube',
          name: 'YouTube',
        },
      },
    };
  },
};
</script>

<style lang="postcss" scoped>
.social-links {
  @apply flex items-center justify-center gap-xxs;
}
</style>
